import { createContext, Dispatch, SetStateAction } from 'react';
import { FormInstance } from 'antd';

import { AdditionalDataSectionForm, PaymentMethodSectionForm, TableObjectItem } from './StepFourFormProvider';
import { CreditCardsInsured, PaymentMethodForms } from '../../../../../../../../shared/interfaces';
import { TransferRightsFormData } from '../../../../../../../../shared/interfaces/services/transfer-rights-service';
import { Dayjs } from 'dayjs';

interface StepFourFormContextProps {
  additionalDataFormValues:           AdditionalDataSectionForm | undefined;    
  setAdditionalDataFormValues:        Dispatch<SetStateAction<AdditionalDataSectionForm | undefined>>;

  additionalDataSectionForm:          FormInstance<AdditionalDataSectionForm>;

  errorCreditCardMessage:             string;
  setErrorCreditCardMessage:          Dispatch<SetStateAction<string>>;

  listCreditCardInsured:              CreditCardsInsured | undefined;
  setListCreditCardInsured:           Dispatch<SetStateAction<CreditCardsInsured | undefined>>;

  methodSelectedFromStepThree:        PaymentMethodForms | undefined;
  setMethodSelectedFromStepThree:     Dispatch<SetStateAction<PaymentMethodForms | undefined>>;

  paymentMethodFormValues:            PaymentMethodSectionForm | undefined;
  setPaymentMethodFormValues:         Dispatch< SetStateAction<PaymentMethodSectionForm | undefined>>;

  paymentMethodSectionForm:           FormInstance<PaymentMethodSectionForm>;

  propertyDataForm:                   FormInstance<any>;

  validitySectionForm:                FormInstance<{ validityDate: Dayjs[] | null }>;

  objectsForm:                        FormInstance<any>;

  setTransferRightsList:              Dispatch<SetStateAction<TransferRightsFormData[]>>;
  transferRightsList:                 TransferRightsFormData[];
}

export const StepFourFormContext = createContext(
  {} as StepFourFormContextProps
);
